import { FC } from 'react';
import { Form } from 'formik';
import { Modal as QcsModal } from '@mui/material';
import { QcsModalBox } from '../../common/basic/QcsModalBox';
import { SectionHeader } from '../../common/SectionHeader';
import { FormikDebounce } from '../../common/form/FormikDebounce';
import { FormContainer } from '../../common/form/FormContainer';
import { SupplierEmployeeAutocomplete } from '../../common/form/SupplierEmployeeAutocomplete';
import { SubmitButton } from '../../common/form/SubmitButton';
import { useInvitation } from './Tabs/invitationFunctions';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserRole } from '@api/models/enums/UserRole';
import { UserState } from '@api/models/enums/UserState';
import * as Yup from 'yup';
import { validations } from '../../../utils/validations';
import { doNothing } from '../../../utils/shared';

interface Props {
  open: boolean;
  title: string;
  onClose?: () => void;
  onSubmit: (responsiblePerson: SupplierEmployeeDto) => Promise<void>;
}

interface FormValues {
  responsiblePerson: SupplierEmployeeDto | null;
}

export const SelectResponsiblePersonModal: FC<Props> = ({ open, title, onClose, onSubmit }) => {
  const { t, invitation } = useInvitation();

  const handleSubmit = async (values: FormValues) => {
    await onSubmit(values.responsiblePerson!);
  };

  return (
    <QcsModal open={open} onClose={onClose ?? doNothing}>
      <QcsModalBox>
        <SectionHeader title={title} />
        <FormikDebounce<FormValues>
          initialValues={{ responsiblePerson: null }}
          validationSchema={Yup.object({
            responsiblePerson: validations.objectRequired(t),
          })}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <FormContainer>
                <SupplierEmployeeAutocomplete
                  name="responsiblePerson"
                  label={t('invitation.responsibleSupplierPerson')}
                  required
                  supplierId={invitation.supplier?.id}
                  role={UserRole.ExternalManager}
                  state={[UserState.Active, UserState.Invited]}
                />
                <SubmitButton text="common.save" />
              </FormContainer>
            </Form>
          )}
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
